import ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

var controller;

// image fade in animation settings
function initFadeImageAni(target, triggerHook, reverse) {
  if (reverse) {
    reverse = true;
  } else {
    reverse = false;
  }

  var duration = 0.5;
  var tweenArr = [];

  // set up frame animation
  // check for existence of frame sibling element
  var frame = $(target).siblings('.frame').first();
  if (frame.length > 0) {
    frame.addClass('frame-follow-' + target.replace('.', ''));
    tweenArr.push(TweenMax.to('.frame-follow-' + target.replace('.', ''), duration, {
      opacity: 1
    }));
  }

  tweenArr.push(TweenMax.to(target, duration, {
    opacity: 1
  }));

  // init scene, add timeline, add to controller
  new ScrollMagic.Scene({
    reverse: reverse,
    triggerElement: target,
    triggerHook: triggerHook
  })
  .setTween(new TimelineMax({
    align: 'normal',
    stagger: 0.5,
    tweens: tweenArr
  }))
  // .addIndicators({name: target.replace(".", "")})
  .addTo(controller);
}

function initFadeUpAni(target, triggerHook) {
  new ScrollMagic.Scene({
    reverse: false,
    triggerElement: target,
    triggerHook: triggerHook
  })
  .setTween(target, 0.5, {
    opacity: 1,
    transform: 'translateY(0)'
  })
  // .addIndicators({name: "fade-up-" + i})
  .addTo(controller);
}

// image uncrop animation
function initUncropAni(horizontal, vertical, triggerHook) {
  var duration = 1600;

  new ScrollMagic.Scene({
    duration: duration,
    triggerElement: horizontal,
    triggerHook: triggerHook
  })
  .setTween(horizontal, 0.5, {
    width: 0
  })
  // .addIndicators({name: "uncrop-horizontal-" + i})
  .addTo(controller);

  new ScrollMagic.Scene({
    duration: duration,
    triggerElement: vertical,
    triggerHook: triggerHook
  })
  .setTween(vertical, 0.5, {
    height: 0
  })
  // .addIndicators({name: "uncrop-vertical-" + i})
  .addTo(controller);
}

// initScrollEffects = function() {
function initScrollEffects() {
  controller = new ScrollMagic.Controller();

  // animate images
  $('section').not('.featured,.projects,.project-gallery').find('.col-image img, .bg-image').each(function(i) {
    $(this).addClass('image-fade-' + i);

    // special case for image in section after featured
    if ($(this).parents('section').prev('section.featured').length === 1) {
      initFadeImageAni('.image-fade-' + i, 0.7, true);

    // all other images
    } else {
      initFadeImageAni('.image-fade-' + i, 0.7);
    }
  });

  // animate map
  $('.map').each(function(i) {
    $(this).addClass('map-fade-' + i);
    initFadeImageAni('.map-fade-' + i, 0.4);
  });

  // animate form
  $('section').find('form').each(function(i) {
    $(this).addClass('form-fade-' + i);
    initFadeImageAni('.form-fade-' + i, 0.4);
  });

  // animate text blocks
  $('section').not('.featured,.projects').find('.container > h1, .container > h2, .container > h3, .container > h4, .container > p, .container > ul > li, .col-text > h1, .col-text > h2, .col-text > h3, .col-text > h4, .col-text > p, .col-text > ul > li').each(function(i) {
    $(this).addClass('fade-up-' + i);

    // special case for element above footer
    if ($(this).parents('section').next('footer').length === 1) {
      initFadeUpAni('.fade-up-' + i, 0.9);

    // special case for element after featured
    } else if ($(this).parents('section').prev('section.featured').length === 1 && $(this).filter('h1, h2, h3, h4, h5, h6').length > 0) {
      initFadeUpAni('.fade-up-' + i, 1);

    } else {
      initFadeUpAni('.fade-up-' + i, 0.8);
    }
  });

  // animate project teasers
  $('section.projects article').each(function(i) {
    $(this).addClass('project-fade-up-' + i);

    var offset = -25;
    var stagger = 250;

    // stagger trigger hook for side-by-side images
    // and also move down triggerhook for top row
    // three across
    if ($(window).width() >= 1200) {
      if (i === 0) {
        $('.project-fade-up-' + i).animate({
          opacity: 1,
          top: offset
        }, 500);
      } else if (i === 1) {
        setTimeout(function(){
          $('.project-fade-up-' + i).animate({
            opacity: 1,
            top: offset
          }, 500);
        }, stagger);
      } else if (i === 2) {
        setTimeout(function(){
          $('.project-fade-up-' + i).animate({
            opacity: 1,
            top: offset
          }, 500);
        }, stagger*2);
      } else if (i % 3 === 2) {
        initFadeUpAni('.project-fade-up-' + i, 0.5);
      } else if (i % 3 === 1) {
        initFadeUpAni('.project-fade-up-' + i, 0.6);
      } else {
        initFadeUpAni('.project-fade-up-' + i, 0.7);
      }

    // two across
    } else if ($(window).width() >= 800) {
      if (i === 0) {
        $('.project-fade-up-' + i).animate({
          opacity: 1,
          top: offset
        }, 500);
      } else if (i === 1) {
        setTimeout(function(){
          $('.project-fade-up-' + i).animate({
            opacity: 1,
            top: offset
          }, 500);
        }, stagger);
      } else if (i < 2) {
        initFadeUpAni('.project-fade-up-' + i, 1);
      } else if (i % 2 === 1) {
        initFadeUpAni('.project-fade-up-' + i, 0.6);
      } else {
        initFadeUpAni('.project-fade-up-' + i, 0.7);
      }

    // one column
    } else {
      if (i === 0) {
        initFadeUpAni('.project-fade-up-' + i, 1);
      } else {
        initFadeUpAni('.project-fade-up-' + i, 0.7);
      }
    }
  });

  // animate project gallery images
  $('section.project-gallery img, .image-gallery__item img').each(function(i) {
    // initialize fade effect
    $(this).addClass('project-gallery-fade-up-' + i);

    // account for fading in image from left to right
    if ($(this).closest('.side-by-side').length > 0 && $(window).width() >= 800 && (($(this).closest('.side-by-side.primary_right').length > 0 && $(this).parent('figure').is('.primary')) || ($(this).closest('.side-by-side.primary_left').length > 0 && $(this).parent('figure').is('.secondary')))) {
      initFadeUpAni('.project-gallery-fade-up-' + i, 0.3);
    } else {
      initFadeUpAni('.project-gallery-fade-up-' + i, 0.75);
    }

    // initialize uncrop effect
    if ($(window).width() >= 800) {
      var horizontalObj = $(this).siblings('.right');
      var verticalObj = $(this).siblings('.top');
      if (horizontalObj.length > 0 && verticalObj.length > 0) {
        horizontalObj.addClass('project-gallery-crop-h-' + i);
        verticalObj.addClass('project-gallery-crop-v-' + i);
        initUncropAni('.project-gallery-crop-h-' + i, '.project-gallery-crop-v-' + i, 1);
      }
    }
  });

  // animate top bar
  new ScrollMagic.Scene({
    offset: 175,
    triggerHook: 0
  })
  .on('enter', function(event) {
    // console.log('entered');
    $('header').addClass('banner--small');
  })
  .on('leave', function(event) {
    // console.log('exited');
    $('header').removeClass('banner--small');
  })
  //.addIndicators({name: 'header'})
  .addTo(controller);

};

// project top section scroll effect
if ( $('.single-project .featured + .text_content').length > 0 ) {
  var $top_section = $('.single-project .featured + .text_content');
  var scroll_offset = 100; // how far the user scrolls before we trigger

  window.addEventListener('scroll', function(e) {
    if (window.scrollY < scroll_offset) {
      $top_section.removeClass('text_content--overlap');
    } else {
      $top_section.addClass('text_content--overlap');
    }
  });
}

export { initScrollEffects }
